import { COMPANY_LOGO } from 'config'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export const LogoBlue = () => {
  const brokerDetail = useSelector((state: any) => state.auth.profile.brokerDetail)
  const [logoUrl, setLogoUrl] = useState(COMPANY_LOGO)
  useEffect(() => {
    setLogoUrl(brokerDetail?.logoUrl || COMPANY_LOGO)
  }, [brokerDetail])

  return <img src={logoUrl} className="max-w-[20rem] max-h-11" />
}
